import styled from 'styled-components'

export const List = styled.ul`
  list-style: none;
  padding-inline-start: 10px;
  padding-left: 0;

  & > li {
    display: flex;
    align-items: center;
    padding-left: 8px;
    margin-bottom: 20px;
  }

  .icon-marker {
    margin-right: 8px;
  }

  & > li:last-child::marker {
    content: 'x ';
    color: red;
    margin-right: 100px;
  }
`
